const o = "_box_xf4xz_1", _ = "_white_xf4xz_20", e = "_yellow_xf4xz_23", x = "_darkblue_xf4xz_26", t = {
  box: o,
  white: _,
  yellow: e,
  darkblue: x,
  "form-section": "_form-section_xf4xz_53"
};
export {
  o as box,
  x as darkblue,
  t as default,
  _ as white,
  e as yellow
};
//# sourceMappingURL=box.module.less.js.map
